export default class AutoLogin {
  public static of(value: boolean): AutoLogin {
    return new AutoLogin(value);
  }

  public static empty(): AutoLogin {
    return AutoLogin.of(false);
  }

  private readonly _value: boolean = false;

  constructor(value: boolean) {
    this._value = value;
  }

  get value(): boolean {
    return this._value;
  }
}